var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2H14C15.1046 2 16 2.89543 16 4V11H20C21.1046 11 22 11.8954 22 13V21C22 21.5523 21.5523 22 21 22H15H9H3C2.44772 22 2 21.5523 2 21V8.5C2 7.39543 2.89543 6.5 4 6.5H8V4C8 2.89543 8.89543 2 10 2ZM10 8.5V20H14V13V4H10V8.5ZM8 8.5H4V20H8V8.5ZM16 20H20V13H16V20Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.42b9029d1fb8a6102d733519349e01d0.svg";
export { ForwardRef as ReactComponent };